<div class="flex flex-column gap-4 border-1 border-round-lg p-3 mt-3 border-bluegray-200" style="background-color: #F9FBFD;">
  <div class="flex flex-column gap-3">
    <!-- <div class="flex flex-column gap-2">
      <b class="block text-left font-bold">Select Activity</b>
      <p-dropdown [options]="extracurricularActivities" class="w-full" [(ngModel)]="selectedExtracurricularOption"
        name="selectedActivity" required styleClass="dropdown" optionLabel="title" optionValue="value"
        placeholder="Select a activity" (onChange)="onActivityChange($event)">
      </p-dropdown>
    </div> -->
    <div class="w-full gap-3"  >
      <div class="w-full flex gap-3">
        <div class="flex flex-column flex-1 gap-2">
          <b class="block text-left font-bold">Activity Type</b>
          <b class="disabled-activity-fld">
            {{activity.otherActivityName!=null?
            activity.otherActivityName:
            activity.activityName}}</b>
        </div>
        <div class="flex flex-column flex-1 gap-2">
          <b class="block text-left font-bold">Organization Name</b>
          <b class="disabled-activity-fld">{{activity.organisationName}}</b>
        </div>
      </div>
      <div class="w-full flex gap-3">
        <div class="flex flex-column flex-1 gap-2">
          <b class="block text-left font-bold">Tier</b>
          <b *ngIf="!activity.levelOfAchievement" class="disabled-activity-fld">N/A</b>
          <b *ngIf="activity.levelOfAchievement" class="disabled-activity-fld">Tier {{activity.levelOfAchievement}}</b>
        </div>
        <!-- <div class="flex flex-column flex-1 gap-2">
          <b class="block text-left font-bold">Participation grade level</b>
          <b class="disabled-activity-fld">{{activity.participationGradeLevels}}</b>
        </div> -->
        <div class="flex flex-column flex-1 gap-2">
          <b class="block text-left font-bold">Position / Leadership description 
            <!-- <span class="font-normal text-bluegray-500">(0 / 50 characters)</span> -->
          </b>
          <b class="disabled-activity-fld">{{activity.positionInActivity}}</b>
        </div>
      </div>
      <!-- <div class="flex flex-column gap-2">
        <b class="block text-left font-bold">Position / Leadership description <span
            class="font-normal text-bluegray-500">(0 / 50 characters)</span></b>
        <b class="disabled-activity-fld">{{activity.positionInActivity}}</b>
      </div> -->
      <div class="flex flex-column gap-2">
        <b class="block text-left font-bold">Description <span
            class="font-normal text-bluegray-500">({{wordCount}} / 150
            words)</span></b>
        <app-content-editor [htmlContent]="initialContent" (onContentChange)="onActivityDescriptionChange($event)">
        </app-content-editor>
        <small class="ng-dirty ng-invalid text-red-500"
          *ngIf="activity.textDescription?.length==0 && isExtraCurricularSubmitted">
          Content is required
        </small>
      </div>
      <div class="w-full flex ">
        <p-button label=".docx" icon="pi pi-download"
        styleClass="download"  class="w-full sm:w-auto" />
      </div>
    </div>
  </div>
  <div class="w-full flex flex-column sm:flex-row gap-3 align-items-center justify-content-center">
    <p-button label="Send to Mentor" [loading]="isLoading" [disabled]="!activity"
      styleClass="sendMentor" (onClick)="onActivitySubmit()" class="w-full sm:w-auto" />
  </div>
</div>
